<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["click"]);

function onClick() {
  if (props.disabled) {
    return;
  }
  emits("click");
}
</script>

<template>
  <a :class="{ disabled: disabled }" href="javascript:void(0)" @click="onClick"
    ><slot
  /></a>
</template>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
